import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Gruppe } from '../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

export class HitSyncEinstellungenInput {
    gruppe: Gruppe;
}

export class HitSyncEinstellungenResult {
    gruppe: Gruppe;
    confirmed: boolean;
}

@Component({
    selector: 'kiene-hit-sync-einstellungen-dialog',
    templateUrl: './hit-sync-einstellungen-dialog.component.html',
    styleUrls: ['./hit-sync-einstellungen-dialog.component.scss'],
})
export class HitSyncEinstellungenDialogComponent implements OnInit {
    active: boolean;

    constructor(
        public dialogRef: MatDialogRef<HitSyncEinstellungenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public input: HitSyncEinstellungenInput,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneBackendApiService,
        private message: MessageService,
    ) {}

    ngOnInit(): void {
        this.active = Number(this.input.gruppe.hit_sync_aktiv) > 0;
    }

    public save(): void {
        this.input.gruppe.hit_sync_aktiv = this.active ? 1 : 0;
        this.api.post(this.apiBaseUrl + 'gruppe/hit_sync_einstellungen.php', this.input.gruppe).subscribe({
            next: response => {
                const result = new HitSyncEinstellungenResult();
                result.confirmed = true;
                result.gruppe = response;
                this.message.infoMessage('HIT-Sync-Einstellungen gespeichert');

                this.dialogRef.close(result);
            },
            error: error => {
                this.message.errorMessage('Fehler beim Speichern der HIT-Sync-Einstellungen', error);
            },
        });
    }
}
